import { ModuleWithProviders, NgModule } from '@angular/core';

import { I18NEXT_NAMESPACE, I18NextModule } from 'angular-i18next';

import { I18N_NAMESPACE } from '@hdms/shared/util-core';

/**
 * TranslationModule is intended to be used in feature libs only.
 *
 * Its purpose is to replace I18NextModule when it should be imported
 * into any feature module respectively standalone component, as any
 * additional I18NextModule import will reset I18NEXT_NAMESPACE value.
 *
 * By reassigning I18N_NAMESPACE token value to I18NEXT_NAMESPACE,
 * TranslationModule ensures that I18NEXT_NAMESPACE value stays set
 * in current scope.
 */

@NgModule({
  imports: [I18NextModule],
  exports: [I18NextModule],
  providers: [
    {
      provide: I18NEXT_NAMESPACE,
      useExisting: I18N_NAMESPACE
    }
  ]
})
export class TranslationModule {
  static forRoot(namespace = ''): ModuleWithProviders<TranslationModule> {
    return {
      ngModule: TranslationModule,
      providers: [
        I18NextModule.forRoot().providers,
        {
          provide: I18N_NAMESPACE,
          useValue: namespace
        }
      ]
    };
  }
}
